import './index-metrics-tab-content.style.scss'

class indexMetricsTabContentController {
    constructor() {
        'ngInject';
    }
}

export default indexMetricsTabContentController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metrics-tab-content/index-metrics-tab-content.controller.js